import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Record} from 'immutable';
import {Link, browserHistory} from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import {Request, PUT, DELETE} from 'requests';
import {default as RequestsMixin, IS_DONE, HAS_FAILED, HAS_ERRORS} from 'requests/RequestsMixin';
import {ResourcesMatching, HasErrors} from 'requests/components';
import OptimizedForSelect from './OptimizedForSelect';
import {default as PasteOrDropzone, SVG, PASTE, DROPZONE} from './PasteOrDropzone';
import RemoveIconModal from './RemoveIconModal';
import SvgInspection from './SvgInspection';
import * as actions from '../actions';

const UpdateWorkingSetIcon = Record({
  name: null,
  optimizedFor: null,
  unicodeChar: null,
  logo: false,
  svg: '',
  ignoreWarnings: false,
});

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
  };
};

const EditIconForm = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
    workingSetIcon: ImmutablePropTypes.record,
    allowSvgEditing: PropTypes.bool.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      name: this.props.workingSetIcon.name,
      unicodeChar: this.props.workingSetIcon.unicodeChar,
      optimizedFor: this.props.workingSetIcon.optimizedFor,
      showPasteSvgSource: true,
      showConfirmDeleteIcon: false,
      dropzone: null,
      svgSource: (this.props.workingSetIcon) ? this.props.workingSetIcon.svg : null,
      svgInspection: null,
      svgErrors: null,
    };
  },

  componentWillReceiveProps(props) {
    if (!this.state.svgSource) {
      this.setState({
        svgSource: (this.props.workingSetIcon) ? this.props.workingSetIcon.svg : null,
      });
    }
  },

  transitions(register) {
    register({
      request: this.requests.updateWorkingSetIcon,
      to: IS_DONE,
      call(rm) {
        this.handleUpdateComplete();
      },
    });

    register({
      request: this.requests.deleteWorkingSetIcon,
      to: IS_DONE,
      call(rm) {
        this.handleDeleteComplete();
      },
    });

    register({
      request: this.requests.updateWorkingSetIcon,
      to: HAS_ERRORS,
      call(rm) {
        const svgErrors = rm.requests.errorsFor(this.requests.updateWorkingSetIcon).get('svg');

        if (typeof svgErrors === 'object') {
          this.setState({
            svgInspection: svgErrors[0],
          });
        } else {
          this.setState({
            svgErrors,
          });
        }
      },
    });

    register({
      request: this.requests.updateWorkingSetIcon,
      to: HAS_FAILED,
      call(rm) {
        this.clearRequests();

        this.setState({
          buildFailed: true,
        });

        if (this.state.dropzone) {
          this.state.dropzone.removeAllFiles();
        }
      },
    });
  },

  handleUpdateComplete() {
    browserHistory.push(`/kits/${this.props.kitToken}/icons`);
  },

  handleDeleteComplete() {
    browserHistory.push(`/kits/${this.props.kitToken}/icons`);
  },

  handleFileRemoved() {
    this.setState({
      svgInspection: null,
      svgErrors: null,
    });
  },

  handleDropzoneInit(dropzone) {
    this.setState({
      dropzone,
    });
  },

  handleSvgChanged(svgSource) {
    this.setState({
      svgSource,
    });
  },

  handleNameChanged() {
    this.setState({
      name: this._name.value,
    });
  },

  handleUnicodeCharChanged() {
    this.setState({
      unicodeChar: this._unicodeChar.value,
    });
  },

  handleOptimizedForChanged(value) {
    this.setState({
      optimizedFor: value,
    });
  },

  handleToggleSourceVersusUpload(event) {
    event.preventDefault();

    this.setState({
      showPasteSvgSource: !this.state.showPasteSvgSource,
    });
  },

  handleSaveClicked(event) {
    event.preventDefault();

    this.upload();
  },

  handleUploadAnyway() {
    this.setState({
      svgInspection: null,
    });

    this.upload(true);
  },

  upload(force = false) {
    this.setState({
      svgInspection: null,
      svgErrors: null,
    });

    if (this.state.showPasteSvgSource) {
      this.updateSvgSource(force);
    } else {
      this.updateViaDropzone(force);
    }
  },

  updateRecord(force) {
    return UpdateWorkingSetIcon({
      name: this._name.value,
      unicodeChar: this.state.unicodeChar,
      optimizedFor: this.state.optimizedFor,
      logo: this.props.workingSetIcon.logo,
      ignoreWarnings: force,
    });
  },

  updateSvgSource(force) {
    const record = this.updateRecord(force)
      .set('svg', this.state.svgSource);

    this.setRequest({
      updateWorkingSetIcon: new Request({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', this.props.workingSetIcon.id],
        method: PUT,
        record,
      }),
    });
  },

  updateViaDropzone(force) {
    const record = this.updateRecord(force);
    const request = new Request({
      url: ['api', 'kits', this.props.kitToken, 'working-set-icons', this.props.workingSetIcon.id],
      method: PUT,
      record,
    });

    this.setRequest({
      updateWorkingSetIcon: request,
    }, {skipDispatch: true});

    this.props.dispatch(
      actions.updateWorkingSetIconFromDropzone(request, record, this.state.dropzone)
    );
  },

  handleDeleteClicked(event) {
    event.preventDefault();

    if (this.props.workingSetIcon.custom) {
      this.setState({
        showConfirmDeleteIcon: true,
      });
    } else {
      this.deleteWorkingSetIcon();
    }
  },

  handleDeleteIconConfirmed() {
    this.setState({
      showConfirmDeleteIcon: false,
    }, () => {
      this.deleteWorkingSetIcon();
    });
  },

  handleDeleteIconCanceled() {
    this.setState({
      showConfirmDeleteIcon: false,
    });
  },

  deleteWorkingSetIcon() {
    this.setRequest({
      deleteWorkingSetIcon: new Request({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', this.props.workingSetIcon.id],
        method: DELETE,
        record: this.props.workingSetIcon,
      }),
    });
  },

  renderPastOrDropzone(which) {
    const {svgErrors} = this.state;

    return (
      <PasteOrDropzone
        onDropzoneInit={this.handleDropzoneInit}
        onSourceChanged={this.handleSvgChanged}
        onSuggestedFilename={this.handleSuggestedFilename}
        onFileRemoved={this.handleFileRemoved}
        source={this.props.workingSetIcon.svg}
        error={svgErrors}
        type={SVG}
        which={which}
      />
    );
  },

  renderPaste() {
    const changeSourceOrUpload = (
      <p>
        <a onClick={this.handleToggleSourceVersusUpload} href="#">Need to upload an SVG file instead?</a>
      </p>
    );
    return (
      <div>
        {this.renderPastOrDropzone(PASTE)}
        <div className="form-group row">
          <div className="col-xs-9 col-xs-offset-3">
            {changeSourceOrUpload}
          </div>
        </div>
      </div>
    );
  },

  renderDropzone() {
    const changeSourceOrUpload = (
      <p>
        <a onClick={this.handleToggleSourceVersusUpload} href="#">Want to paste from Illustrator CC instead?</a>
      </p>
    );
    return (
      <div>
        {this.renderPastOrDropzone(DROPZONE)}
        <div className="form-group row">
          <div className="col-xs-9 col-xs-offset-3">
            {changeSourceOrUpload}
          </div>
        </div>
      </div>
    );
  },

  renderError() {
    const rm = this.resourceManager();
    const {svgInspection} = this.state;
    let error = null;

    if (svgInspection) {
      error = <SvgInspection onContinueAnyway={this.handleUploadAnyway} results={svgInspection} />;
    }

    if (rm.requests.hasFailed(this.requests.updateWorkingSetIcon)) {
      error = (
        <div id="build-error" className="alert alert-warning" role="alert">
          <strong>Oi!</strong> We had trouble saving your icon. Why don&rsquo;t you try again.
        </div>
      );
    }

    if (rm.requests.hasFailed(this.requests.deleteWorkingSetIcon)) {
      error = (
        <div id="build-error" className="alert alert-danger" role="alert">
          <strong>Oops!</strong> There was an issue deleting your custom icon. Our support team has been notified.
        </div>
      );
    }

    return error;
  },

  render() {
    const {workingSetIcon, allowSvgEditing} = this.props;
    const {
      updateWorkingSetIcon: updateWorkingSetIconRequest,
    } = this.requests;
    const custom = workingSetIcon.custom;
    const rm = this.resourceManager();
    const formGroupClassName = classnames('form-group', 'row', 'string', 'required');
    const nameFormGroupClassName = classnames(
      formGroupClassName,
      {'has-danger': rm.requests.errorsFor(updateWorkingSetIconRequest).get('name')}
    );
    const unicodeCharFormGroupClassName = classnames(
      formGroupClassName,
      {'has-danger': rm.requests.errorsFor(updateWorkingSetIconRequest).get('unicodeChar')}
    );

    const deleteIconClassName = (custom) ?
      classnames('ficon', 'p-xs-l-xs', 'ficon-trash') :
      classnames('ficon', 'p-xs-l-xs', 'ficon-times-circle');
    const deleteDisabled = rm.requests.isQueued(this.requests.deleteWorkingSetIcon);
    let saveDisabled = rm.requests.isQueued(this.requests.updateWorkingSetIcon);
    const somethingFailed = rm.requests.hasFailed(this.requests.updateWorkingSetIcon);
    let deleteLabel = (deleteDisabled) ? 'Deleting...' : 'Delete Icon';
    let saveLabel = <span>Edit Icon <i className="ficon ficon-check-circle p-xs-l-xs" /></span>;
    let editSvg = null;

    if (somethingFailed) {
      saveDisabled = false;
    }

    if (saveDisabled) {
      saveLabel = 'Saving...';
    }

    if (allowSvgEditing) {
      editSvg = (this.state.showPasteSvgSource) ? this.renderPaste() : this.renderDropzone();
    }

    return (
      <ResourcesMatching manager={rm}>
        <div>
          <RemoveIconModal
            show={this.state.showConfirmDeleteIcon}
            kitToken={this.props.kitToken}
            workingSetIcon={this.props.workingSetIcon}
            onRemovedIcon={this.handleDeleteIconConfirmed}
            onClosed={this.handleDeleteIconCanceled}
          />

          {this.renderError()}

          <form className="simple-form form-horizontal">
            <div className={nameFormGroupClassName}>
              <label className="string required col-xs-3 form-control-label p-xs-r-sm">Icon Name <span title="Required">*</span></label>
              <div className="col-xs-9">
                <input ref={(input) => (this._name = input)} onChange={this.handleNameChanged} className="string required form-control" type="text" value={this.state.name} />
                <HasErrors request={updateWorkingSetIconRequest} errorKey="name">
                  <span className="text-help text-muted p-xs-t-xs">{rm.requests.errorsFor(updateWorkingSetIconRequest).get('name')}</span>
                </HasErrors>
                <p className="text-muted p-xs-t-xs">Lowercase letters, numbers, and hyphens allowed.</p>
              </div>
            </div>
            <div className={formGroupClassName}>
              <label className="string required col-xs-3 form-control-label p-xs-r-sm">Optimized for <span title="Required">*</span></label>
              <div className="col-xs-9">
                <OptimizedForSelect disabled={!allowSvgEditing} onChanged={this.handleOptimizedForChanged} value={this.state.optimizedFor} />
                <p className="text-muted p-xs-t-xs">The size you&rsquo;ve designed your icon to look the best at.</p>
              </div>
            </div>
            {editSvg}
            <div className={unicodeCharFormGroupClassName}>
              <label className="string required col-xs-3 form-control-label p-xs-r-sm">Unicode <span title="Required">*</span></label>
              <div className="col-xs-9">
                <input ref={(input) => (this._unicodeChar = input)} onChange={this.handleUnicodeCharChanged} className="string required form-control" type="text" value={this.state.unicodeChar} />
                <HasErrors request={updateWorkingSetIconRequest} errorKey="unicodeChar">
                  <span className="text-help text-muted p-xs-t-xs">{rm.requests.errorsFor(updateWorkingSetIconRequest).get('unicodeChar')}</span>
                </HasErrors>
              </div>
            </div>
            <div className={formGroupClassName}>
              <div className="col-xs-9 col-xs-offset-3">
                <button onClick={this.handleSaveClicked} disabled={saveDisabled} className="btn btn-primary btn-block btn-lg">{saveLabel}</button>
                <div className="hr m-xs-t-md"><span className="hr-text bg-white">or</span></div>
              </div>
            </div>
          </form>
          <div className="row m-xs-b-md">
            <div className="col-xs-3 col-xs-offset-3 p-xs-r-sm">
              <Link to={`/kits/${this.props.kitToken}/icons`} className="btn btn-secondary btn-block btn-lg">Cancel</Link>
            </div>
            <div className="col-xs-6 p-xs-l-0">
              <a onClick={this.handleDeleteClicked} disabled={deleteDisabled} className="btn btn-secondary btn-block btn-lg">{deleteLabel} <i className={deleteIconClassName}></i></a>
            </div>
          </div>
        </div>
      </ResourcesMatching>
    );
  },

});

export default connect(mapStateToProps)(EditIconForm);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/EditIconForm.js